/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* istanbul ignore file */

//  @ts-nocheck

/* eslint-disable no-unused-vars */
import calculatePosition from './calculatePosition';
import Position from '@react/react-spectrum/OverlayTrigger/js/Position';
import getContainer from 'react-overlays/lib/utils/getContainer';
import ownerDocument from 'react-overlays/lib/utils/ownerDocument';
import filterDOMProps from '@react/react-spectrum/utils/filterDOMProps';
import classNames from 'classnames';
import React, { cloneElement } from 'react';
import ReactDOM from 'react-dom';

/* eslint-enable no-unused-vars */

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
export default class LanguageSwitcherPosition extends Position {
	updatePosition(target) {
		const { placement, containerPadding, offset, crossOffset, flip, boundariesElement } = this.props;
		this._lastTarget = target;

		if (!target) {
			this.setState({
				positionLeft: 0,
				positionTop: 0,
				arrowOffsetLeft: null,
				arrowOffsetTop: null,
			});

			return;
		}

		const overlay = ReactDOM.findDOMNode(this);
		const container = getContainer(this.props.container, ownerDocument(this).body);

		this.setState(
			calculatePosition(
				placement,
				overlay,
				target,
				container,
				containerPadding,
				flip,
				boundariesElement,
				offset,
				crossOffset,
			),
		);
	}

	render() {
		const { children, className, ...props } = this.props;
		const { positionLeft, positionTop, maxHeight, arrowOffsetLeft, arrowOffsetTop, placement } = this.state;

		const height = maxHeight ? maxHeight : 634;

		delete props.target;
		const child = React.Children.only(children);
		return cloneElement(child, {
			...filterDOMProps(props),
			placement,
			className: classNames(className, child.props.className),
			arrowStyle: {
				left: arrowOffsetLeft,
				top: arrowOffsetTop,
			},
			style: {
				...child.props.style,
				position: 'absolute',
				zIndex: 100000, // should match the z-index in ModalTrigger
				left: positionLeft,
				top: positionTop,
				height,
				maxHeight: height - 16,
			},
		});
	}
}
